import React from "react";
import HeroSection from "../components/Herosection";
import TopRatedRides from "../components/DiscoverYourCabs";
import TestimonialSection from "../components/Testimonials";
import FAQSection from "../components/Faq";
import SafetySection from "../components/safety";

const Home = () => {
    return (
        <div className="home-page">
            <HeroSection />
            <SafetySection />
            <TopRatedRides />
            <TestimonialSection/>
            <FAQSection />
            
        </div>
    );
};
export default Home;